import { Cell } from '@pelckmans/elementis/components/table/cell';

export default function PercentageCell({ achieved, maximum }: { achieved?: number; maximum?: number }) {
  return achieved === undefined || maximum === undefined ? (
    <Cell />
  ) : (
    <Cell pillGroupProps={{ 'aria-label': undefined, role: 'group' }}>
      <Cell.Pill>{(achieved / maximum) * 100}%</Cell.Pill>
    </Cell>
  );
}
